import React from "react";
import "../../styles/index.scss";
import CondPayment from "../CondPayment";
import { CGE } from "../../../../common/components/CGE";
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from "../../../../common/hooks/useCookie";

const PubPa = ({ props }) => {
    const [values, setValues] = React.useState({});
    const [errorCli, setErrorCli] = React.useState(false);

    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });

    const [recaptchaKey, setRecaptchaKey] = React.useState(0);
    const prevIdRef = React.useRef("");

    const propsLabelInfoContent = {
        content: props.state?.webContentTextInfo,
        observer,
        onClose,
        setVisibleModal,
        status: "info",
        titleModal: "Información",
        visibleModal,
        titleHint: "Ayuda Nro de Cliente",
    };

    const objPropPa = {
        webContentHtmlPa: props.webContentHtmlPa,
    };

    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    function handleClickButtonClient() {
        if (values.idClient) {
            setErrorCli(false);
            props.setIdClient(values.idClient);
        } else {
            setErrorCli(true);
        }
    }

    function handleCaptcha(captchaData) {
        updateCookieState(captchaData);
        if (captchaData) {
            props.setIsClientIdCaptchaChecked(true);
        } else {
            props.setIsClientIdCaptchaChecked(false);
        }
    }

    return (
        <div id="container" className="bg-white">
            <div className="margin-web-content-pub-pa">
                {props.showWebContentPa && <CondPayment props={objPropPa} />}
            </div>

            <div className="align-items-center">
                <div className="margin-costumer-number-pub-pa col-md-12">
                    <CGE.DetailClient
                        props={{
                            handleChange: (e) => {
                                const nextVal = e.target.value;
                                setValues({ ...values, idClient: nextVal });


                                if (prevIdRef.current !== nextVal) {
                                    prevIdRef.current = nextVal;
                                    setRecaptchaKey((k) => k + 1);
                                    props.setIsClientIdCaptchaChecked(false);
                                    updateCookieState("");
                                }

                                // Mantén la UX previa:
                                if (props.isNextStep) {
                                    props.setIsClientIdCaptchaChecked(false);
                                }
                                props.setNextStepPag(false);
                            },
                            hasError: errorCli,
                            msgError: "Debe ingresar un Nro de Cliente",
                            idClient: values.idClient,
                            idFormElement: "inputNumClient",
                            labelName: "Número de Cliente",
                            mandatoryElement: true,
                            sizeButton: "sm",
                            typeButton: "primary",
                            valuePub: values.idClient,
                            propsLabelInfoContent: propsLabelInfoContent,
                        }}
                        propsDetail={{
                            fullNameClient: "",
                            comunaClient: props.detailClientJson?.COMUNA ? props.detailClientJson?.COMUNA : "",
                            calleClient: props.detailClientJson?.CALLE ? props.detailClientJson?.CALLE : "",
                            nCalleClient: props.detailClientJson?.NUMERO_CASA ? props.detailClientJson?.NUMERO_CASA : "",
                            dptoBlockClient:
                                (props.detailClientJson?.SUPLEMENTO || props.detailClientJson?.PISO)
                                    ? `${props.detailClientJson?.SUPLEMENTO} ${props.detailClientJson?.PISO}`
                                    : "",
                            ctaCtoClient: props.detailClientJson?.CTA_CTO,
                        }}
                    />

                    {props.isNextStep ? null : (
                        <CGE.FieldRecaptcha key={recaptchaKey} onChange={handleCaptcha} sitekey={props.siteKey} />
                    )}

                    <CGE.Spacing type="md" />
                </div>

                <div className="d-flex align-items-center flex-column">
                    <CGE.Button
                        label="Validar"
                        onClick={() => {
                            if (!props.isNextStep && !props.isClientIdCaptchaChecked) {
                                return props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
                            }
                            if (!values.idClient) {
                                setErrorCli(true);
                                return;
                            }
                            props.setValueCoute("");
                            props.sendClient(values.idClient);
                            handleClickButtonClient();
                        }}
                        type="primary"
                    />
                </div>
            </div>
        </div>
    );
};

export default PubPa;